
import { createContext, useState, useEffect, useContext, useCallback } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../Redux/user/user";
import { getAllOtherNamesSourcesAPICall } from "../api/user/GetAllOtherNamesSource";

export const GenericStatusContext = createContext({
    otherNamesSource: [],
    getAllOtherNamesSources: () => { },
    setOthersNameSource: () => { },
    isWaiting: false,
    setIsWaiting: () => { }
});

const GenericStatusContextProvider = ({ children }) => {

    const [otherNamesSource, setOthersNameSource] = useState([])
    const [isWaiting, setIsWaiting] = useState(false);

    const user = useSelector(selectUser);


    const getAllOtherNamesSources = useCallback(async (callbackError) => {
        try {
            await getAllOtherNamesSourcesAPICall(
                function (response) {
                    setOthersNameSource(response.data.sources)
                },
                function (error) {
                    callbackError();
                }
            );
        } catch (err) {
            callbackError();
        }
    });


    useEffect(() => {
        if (!user) {
            return
        }
        getAllOtherNamesSources((error) => {
            console.log(error)
        })
    }, [user]);

    return (
        <GenericStatusContext.Provider value={{
            otherNamesSource,
            setOthersNameSource,
            getAllOtherNamesSources,
            isWaiting, setIsWaiting
        }}>
            {children}
        </GenericStatusContext.Provider>
    );
};

export const useGenericStatusContext = () => useContext(GenericStatusContext);

export default GenericStatusContextProvider;
